import type {WidgetType} from "constants/WidgetConstants";
import * as React from "react";
import type {WidgetProps, WidgetState} from "widgets/BaseWidget";
import TaroWidget from "widgetsTaro";
import {ValidationTypes} from "constants/WidgetValidation";
import type {Stylesheet} from "entities/AppTheming";
import {DefaultAutocompleteDefinitions} from "widgets/WidgetUtils";
import type {AutocompletionDefinitions} from "widgets/constants";
import TTextWidget from "../component";
import {DerivedPropertiesMap} from "../../../utils/WidgetFactory";
import {EventType} from "../../../constants/AppsmithActionConstants/ActionConstants";
import {fontSizeOptions} from "../../../pages/Editor/ThemePropertyPane/controls/ThemeFormControl";
import {DateFormatOptions} from "../../../widgets/DatePickerWidget2/widget/constants";
import contentConfig from "./contentConfig";
import styleConfig from "./styleConfig";

class TText extends TaroWidget<TTextWidgetProps, WidgetState> {
  constructor(props: TTextWidgetProps) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }
  static getPropertyPaneEventsConfig() {
    return super.getWidgetEvents("AtTextWidget");
  }
  static getAutocompleteDefinitions(): AutocompletionDefinitions {
    return {
      value: "string",
      isVisible: DefaultAutocompleteDefinitions.isVisible,
    };
  }

  static getPropertyPaneContentConfig = contentConfig;
  static getPropertyPaneStyleConfig = styleConfig;

  static getDerivedPropertiesMap(): DerivedPropertiesMap {
    return {
      getValue: `{{ this.text }}`,
      value: `{{ this.text }}`,
    };
  }

  static getStylesheetConfig(): Stylesheet {
    return {
      borderRadius: "{{appsmith.theme.borderRadius.appBorderRadius}}",
      boxShadow: "none",
      color: "{{appsmith.theme.colors.textColor}}",
      fontSize: "{{appsmith.theme.form.label.fontSize}}"
    };
  }
  onClick(){
    if(this.props.onClick){
      super.executeAction({
        triggerPropertyName: "onClick",
        dynamicString: this.props.onClick,
        event: {
          type: EventType.ON_CLICK
        },
      });
    }
  }
  getPageView() {
    return (
      <TTextWidget {...this.props} onClick={this.onClick} />
    );
  }
  static getWidgetType(): WidgetType {
    return "AT_TEXT_WIDGET";
  }
}

export interface TTextWidgetProps extends WidgetProps {
  value: any[];
  label: string;
  onClick?: any;
  borderRadius: string;
  boxShadow?: string;
}

export default TText;
